import { TSobReportSalesType } from 'legacy/lut/components/widgets/public/partner360/configs/reports'

import { Nullable } from 'cng-common/models/utils'
import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

import { getActualsCYQNetNdpField } from '../../getActualsCYQField'
import { getSobQField } from '../../getSobQField'
import { getSumOfNumbers } from '../../getSumOfNumbers'

import { ISobAndRevenue } from './models'

interface ICalculateEstimatedRevenueForPeriod {
  data: ISobAnalyticsReportJoined[]
  quarters: number[]
  revenueField: 'Actuals' | 'Plans' | 'ExpExit'
  sobField: 'Actual' | 'Plan' | 'ExpExit'
  netNdp: TSobReportSalesType
}

// calculate actuals to sob
export const calculateEstimatedRevenue = ({ actuals, sob }: ISobAndRevenue) => {
  const hasPositiveSob = !!sob && sob > 0
  const hasPositiveActuals = !!actuals && actuals > 0

  if (hasPositiveSob && hasPositiveActuals) {
    return (actuals / sob) * 100
  }

  return null
}

// calculate sum actuals to sob
export const calculateEstimatedRevenueForPeriod = ({
  data,
  quarters,
  revenueField,
  sobField,
  netNdp,
}: ICalculateEstimatedRevenueForPeriod) => {
  const quarterFields = quarters.map((quarter) => ({
    actualsField: getActualsCYQNetNdpField({ field: revenueField, quarter, netNdp }),
    sobField: getSobQField({ field: sobField, quarter }),
  }))

  const estimatedRevenues = data.map((record) => {
    const recordValuePairs = quarterFields.map<ISobAndRevenue>((it) => ({
      actuals: ((record as any)[it.actualsField] ?? null) as Nullable<number>,
      sob: ((record as any)[it.sobField] ?? null) as Nullable<number>,
    }))

    const estimatedRevenuesForRecord = recordValuePairs.map((pair) =>
      calculateEstimatedRevenue(pair)
    )

    return getSumOfNumbers(estimatedRevenuesForRecord)
  })

  return getSumOfNumbers(estimatedRevenues)
}
